export default {
  name: 'information',
  path: 'information',
  component: () => import('@/views/information/Information.vue'),
  meta: { title: '消息中心', redirect: false, hideSubMenu: true, },
};